import { axios, setToken } from "@/utils/axios";
import { paymentHeaders } from "@/utils/axiosPayment";
import useConnectionApi from "./useConnection";

const path_stripe_api = process.env.VUE_APP_STRIPE_API_URL;

export default function useUserApi() {

  const signIn = async (username, password) => {
    try {
      console.log("signIn");
      // El servidor valida id_portal/password_portal y devuelve la sesion del
      // portal con la identidad (partner_id) tomada de Odoo. El front ya no lee
      // res.partner con la credencial publica ni firma su propio metadata.
      const { data, status } = await axios.post("/api/portal/login", {
        username,
        password,
      });
      if (status === 200) {
        const { session, user } = data.payload;
        // Token del portal (rol portal): a partir de aqui las lecturas quedan
        // acotadas a este cliente por el backend.
        setToken(session);

        // Alta del customer de Stripe si falta. El write de id_stripe va sobre
        // el propio registro, unico write que el rol portal permite.
        if (user.id_stripe === null || user.id_stripe === false) {
          try {
            const { data: customer } = await createCustomerStripeId(user);
            if (customer && customer.id) {
              await update_customer_id(user.id, customer.id);
              user.id_stripe = customer.id;
              console.log("customer_id:", customer.id);
            }
          } catch (stripeError) {
            console.error("Error creating Stripe customer:", stripeError);
          }
        }
        return user;
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const createCustomerStripeId = async (fields) => {
    console.log("Asignando el customer id ...")
    const path = path_stripe_api + "customers";
    console.log(path);
    const customer = {
      id_odoo: fields.id,
      name: fields.name,
      email: fields.email,
      phone: fields.phone || null,
      description: fields.razon_social || null,
      city: fields.city || null,
      state: fields.state || null,
      postal_code: fields.postal_code || null,
      country: fields.country || "mx",
      line1: fields.line1 || null,
      line2: fields.line2 || null,
    }
    
    try {
      const response = await fetch(path, {
        method: 'POST',
        headers: paymentHeaders({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(customer)
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error creating Stripe customer:', error);
      throw error;
    }
  }

  const publicUser = async () => {
    try {
      // Open connection with public user
      const { openConnection } = useConnectionApi();
      const { data: connection, status: connectionStatus } = await openConnection({type: "public"});
      if (connectionStatus === 200) {
        setToken(connection.payload);
        return connection.payload;
      }
      throw new Error("Failed to authenticate public user");
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  // eslint-disable-next-line no-unused-vars
  const changePassword = async (user_id, current_password, new_password, confirm_password) => {
    try {
      if (new_password !== confirm_password) {
        throw new Error("New password and confirm password do not match");
      }
      // La verificacion de la contrasena actual y la escritura ocurren en el
      // servidor: password_portal ya no viaja al navegador. El partner sale del
      // token del portal, por eso no se envia user_id.
      const { status } = await axios.post("/api/portal/change-password", {
        current_password,
        new_password,
      });
      return status === 200;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const update_customer_id = async (user_id, customer_id) => {
    try {
      console.log("update_customer_id");
      const { data, status } = await axios.post("/api/v1/res.partner", {
        method: "write",
        where: [[parseInt(user_id)], { "id_stripe": customer_id }]
      });
      if (status === 200) {
        console.log("Customer id updated successfully");
        // console.log(data);
        return true;
      }
      throw new Error("Failed to update customer id");
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const sendResetPasswordEmail = async (email) => {
    console.log(email);
    try {
      // Validate email format using regex
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        throw new Error("Invalid email format");
      }

      const { data, status } = await axios.post("/api/v1/mikrotik.servicio", {
        method: "verificar_correo_contacto",
        where: [false, email]
      });

      if (status === 200) {
        return data.payload;
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const newUserPortal = async (service_number) => {
    try {
      console.log("newUserPortal");
      const { data, status } = await axios.post("/api/v1/mikrotik.servicio", {
        method: "crear_usuario_portal_api",
        where: [false, service_number]
      });
      // console.log(data);
      if (status === 200) {
        return data.payload;
      }
      return false;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const sendMailMessage = async (model, res_id, message_type, body) => {
    try {
      const { data, status } = await axios.post("/api/v1/mail.message", {
        method: "create",
        where: [[
          {
            model: model,
            res_id: parseInt(res_id),
            message_type: message_type,
            body: body
          }
        ]]
      });
      if (status === 200) {
        return data.payload;
      }
      return false;
    } catch (error) {
      console.error("Error sending mail message:", error);
      return false;
    }
  }

  return {
    signIn,
    publicUser,
    changePassword,
    sendResetPasswordEmail,
    newUserPortal,
    sendMailMessage
  };
}
